import React, { useEffect, useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import GameSvcCtntCtxtApi from "Apis/GameSvcCtntCtxtApi";
import TrmsLstInqApi from "Apis/TrmsLstInqApi";
import sanitizeHtml from 'sanitize-html';
import MgpStore from "Stores/Store";

import "Assets/css/Trms.css";
import "Assets/css/Ctnt.css";
import { useLocation } from "react-router-dom";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import { set } from "date-fns";

const CtntCtxtUi = ({gameSvcCd,ctntKindCd,ctntSno}:any) => {
    const navigate = useNavigate();
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    const test =() => {
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let getctntKindCd = query.get("ctntKindCd");
    let getctntSno = query.get("ctntSno");
    let getPageState = query.get("pageState");
    const {data: langData}:any = UseLangLstQuery();
    if(getGameSvcCd !=null){
        gameSvcCd = getGameSvcCd;
        ctntKindCd = getctntKindCd;
        ctntSno = getctntSno;
    }

    if(gameSvcCd ==null) {
        gameSvcCd = location.state?.gameSvcCd;
    }
    if(ctntKindCd ==null) {
        ctntKindCd = location.state?.ctntKindCd;
    }

    const [ctntKindCdState,setctntKindCdState] = useState(getctntKindCd);
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const [ctntPstdTitlState,setctntPstdTitlState] = useState<any>();
    const [aplyStrtDtimeState,setAplyStrtDtimeState] = useState<any>();
    const [vwrCntState,setVwrCntState] = useState<any>();
    const [ctntTitlState,setCtntTitlState] = useState("");
    
    let test1:any;
    useEffect(()=>{
        if (!langData) return;
        GameSvcCtntCtxtApi(getGameSvcCd,getctntSno)
        .then((Resp) => {
            setctntPstdTitlState(Resp.apiBody.ctntTitl);
            setAplyStrtDtimeState(Resp.apiBody.aplyStrtDtime);
            setVwrCntState(Resp.apiBody.vwrCnt);
            // const dirty = Resp.apiBody.ctntCtxt;
            // test1 = sanitizeHtml(dirty,{});
            setCtntCtxtState(Resp.apiBody.ctntCtxt);
            switch(ctntKindCdState){
                case "PNOT":
                    setCtntTitlState(langData&&langData.GLB_PNOT_LST_TITL_00);
                break;
                case "UPDT":
                    setCtntTitlState(langData&&langData.GLB_UPDT_LST_TITL_00);
                break;
                case "EVNT":
                    setCtntTitlState(langData&&langData.GLB_EVNT_LST_TITL_00);
                break;
            }
        })
    },[MgpStore.getState().LangSetState.Lang, langData]);
   
   
    return(
        <div className="BgW">
            <div className="csMainBnr newsMainBnr"><h1>{langData&&langData.GLB__COMM_TITL_LBL_00}</h1></div>
            <div className="trmsContainer  ctntCtgr">
                <h1 className="ctntCtgrTitl">{ctntTitlState&&ctntTitlState}</h1>
                <div className="trmsCtgrMenu">
                    <ul>
                        <li className={ctntKindCdState == "PNOT"?"active":""}>
                            <Link to={`/ctnt/ctntLst?gameSvcCd=${gameSvcCd}&ctntKindCd=PNOT&lang=${MgpStore.getState().LangSetState.Lang}`}>
                                <p>{langData&&langData.GLB_PNOT_LST_TITL_00}</p>
                                {/* 공지사항 */}
                            </Link>
                        </li>
                        <li className={ctntKindCdState == "UPDT"?"active":""}>
                            <Link to={`/ctnt/ctntLst?gameSvcCd=${gameSvcCd}&ctntKindCd=UPDT&lang=${MgpStore.getState().LangSetState.Lang}`}>
                                <p>{langData&&langData.GLB_UPDT_LST_TITL_00}</p>
                                {/* 업데이트 */}
                            </Link>
                        </li>
                        <li className={ctntKindCdState == "EVNT"?"active":""}>
                            <Link to={`/ctnt/ctntLst?gameSvcCd=${gameSvcCd}&ctntKindCd=EVNT&lang=${MgpStore.getState().LangSetState.Lang}`}>
                                <p>{langData&&langData.GLB_EVNT_LST_TITL_00}</p>
                                {/* 이벤트 */}
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="trmsCtxtWrap">
                    <div className="ctntTitlWrap">
                        <h1>{ctntPstdTitlState}</h1>
                        <div className="dFlex gap10 alignCenter">
                            <p>{aplyStrtDtimeState}</p>
                            <p className="vwrCnt"><i className="eye"></i>{vwrCntState}</p>
                        </div>
                    </div>
                    {ctntCtxtState != null?
                        <div className="trmsCtxt ctntCtxt" 
                        dangerouslySetInnerHTML={{
                            __html: ctntCtxtState,
                        }}>
                        </div>    
                    :
                    <></>
                    }
                </div>
                <div className="ctntBtnWrap">
                    <Link to={location.state?.returnUrl || `/ctnt/ctntLst?gameSvcCd=MGP&ctntKindCd=${getctntKindCd}&lang=${MgpStore.getState().LangSetState.Lang}`}>
                        <p>{langData&&langData.GLB__COMM_LST_BTN_00}</p>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default CtntCtxtUi;
